import { IDocumentData } from '../components/all-documents-dashboard/model';

export const CONSTANTS = {
  LIBRARY: 'libraries',
  DOCUMENT_LIBRARY: 'documentLibrary',
  FOLDER: 'folder',
  FOLDER_OPEN: 'folder_open',
  EMAIL_TEMPLATES: 'emailTemplates',
  CONTRACT_TEMPLATES: 'contractTemplates',
  CONTENT_TEMPLATES: 'contentTemplates',
  CURRENT_USER: 'currentUser',
  TRACK_CHANGES_AND_COMMENTS_DATA: 'trackchangesandcommentsdata',
  TRACK_CHANGES_AND_COMMENTS_INVOLVED_USERS:
    'trackChangesAndCommentsInvolvedUsers',
  CURRENT_SITE: 'currentSite',
  CURRENT_FOLDER: 'currentFolder',
  THUMB_NAIL: '$thumbnail',
  THUMBNAIL_LAYOUT: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
  DOCUMENT_LIST_LAYOUT_NAME: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
  CSS_CLASS: 'full-width ellipsis-cell',
  DOCUMENT_LIST_LAYOUT_LOCATION: 'ADF-DOCUMENT-LIST.LAYOUT.LOCATION',
  SIZE_BYTES: 'content.sizeInBytes',
  DOCUMENT_LIST_LAYOUT_SIZE: 'ADF-DOCUMENT-LIST.LAYOUT.SIZE',
  DOCUMENT_LIST_LAYOUT_MODIFIED: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_ON',
  USER_NAME: 'modifiedByUser.displayName',
  DOCUMENT_LIST_MODIFIED_BY: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_BY',
  ADD_COLUMNS_USER_CONFIGURATION: 'USER_COLS_CONFIG',
  EMPTY_LABEL: 'Empty',
  EMPTY: 'EMPTY',
  FILTERS_MODELS: 'FILTERS_MODELS',
};

export const SITE_CONTAINER_LABELS = {
  [CONSTANTS.DOCUMENT_LIBRARY]: {
    label: 'APP.DOCUMENT_LIBRARY.TITLE',
    tooltip: 'APP.DOCUMENT_LIBRARY.TILE.TOOLTIP',
  },
  [CONSTANTS.CONTENT_TEMPLATES]: {
    label: 'APP.CONTENT_TEMPLATES.TITLE',
    tooltip: 'APP.CONTENT_TEMPLATES.TILE.TOOLTIP',
  },
  [CONSTANTS.CONTRACT_TEMPLATES]: {
    label: 'APP.CONTRACT_TEMPLATES.TITLE',
    tooltip: 'APP.CONTRACT_TEMPLATES.TILE.TOOLTIP',
  },
  [CONSTANTS.EMAIL_TEMPLATES]: {
    label: 'APP.EMAIL_TEMPLATES.TITLE',
    tooltip: 'APP.EMAIL_TEMPLATES.TILE.TOOLTIP',
  },
};
export interface IReassignTaskDialogData {
  invalidDocumentsList: IDocumentData[];
  selected: IDocumentData[];
}
